module.exports = __webpack_public_path__ + "img/phone-entryEN.176c94fa.png";